import { type Component, Show } from "solid-js";
import { twMerge } from "tailwind-merge";
import styles from "../../PromptBar.module.css";

/**
 * Animated gradient border component for the prompt bar
 */
export const GradientBorder: Component<{
  inset?: number;
  blur?: number;
  scaleX?: number;
  scaleY?: number;
  class?: string;
  noGlow?: boolean;
}> = (props) => {
  return (
    <>
      {/* Gradient Animation Background Layers */}
      <div
        style={{ inset: `${props.inset ?? -3}px` }}
        class={twMerge("overflow-hidden absolute rounded-[1.6rem] z-0 pointer-events-none", props.class)}
      >
        <div
          class={styles["prompt-gradient-animation"]}
          style={{ "--scale-x": props.scaleX ?? 1, "--scale-y": props.scaleY ?? 1 }}
        />
      </div>
      <Show when={!props.noGlow}>
        <div
          class={twMerge("overflow-hidden absolute rounded-[1.6rem] z-0 pointer-events-none", props.class)}
          style={{ inset: "-1px", filter: `blur(${props.blur ?? 8}px)` }}
        >
          <div
            class={styles["prompt-gradient-animation"]}
            style={{ "--scale-x": props.scaleX ?? 1, "--scale-y": props.scaleY ?? 1 }}
          />
        </div>
      </Show>
    </>
  );
};

export const GradientBorderStatic: Component<{
  inset?: number;
  blur?: number;
  class?: string;
  noGlow?: boolean;
}> = (props) => {
  return (
    <>
      {/* Gradient Animation Background Layers */}
      <div
        style={{ inset: `${props.inset ?? -3}px` }}
        class={twMerge(
          "overflow-hidden absolute rounded-[1.6rem] z-0 pointer-events-none",
          styles["prompt-gradient-static"],
          props.class,
        )}
      />
      <Show when={!props.noGlow}>
        <div
          class={twMerge(
            "overflow-hidden absolute rounded-[1.6rem] z-0 pointer-events-none",
            styles["prompt-gradient-static"],
            props.class,
          )}
          style={{ inset: "-1px", filter: `blur(${props.blur ?? 8}px)` }}
        />
      </Show>
    </>
  );
};
